//action types for redux

export const UPDATE_LOGIN = "UPDATE_LOGIN";
export const UPDATE_USER_INFO = "UPDATE_USER_INFO";
export const UPDATE_GOOGLEAUTH = "UPDATE_GOOGLEAUTH";
export const UPDATE_PAGE = "UPDATE_PAGE";
export const UPDATE_STORE = "UPDATE_STORE";

export const CREATE_CLASS = "CREATE_CLASS";
export const UPDATE_CLASSES = "UPDATE_CLASSES";
export const UPDATE_CLASS = "UPDATE_CLASS"
export const GET_CLASSES = "GET_CLASSES";
export const DELETE_CLASS = "DELETE_CLASS";

export const CREATE_GRADEBOOK = "CREATE_GRADEBOOK";
export const UPDATE_CLEAN_GRADEBOOK = "UPDATE_CLEAN_GRADEBOOK"
export const UPDATE_GRADEBOOKLIST = "UPDATE_GRADEBOOKLIST";
export const GET_GRADEBOOK = "GET_GRADEBOOK";
export const GET_GRADEBOOKLIST = "GET_GRADEBOOKLIST";
export const DELETE_GRADEBOOK = "DELETE_GRADEBOOK";

export const UPDATE_ROSTER = "UPDATE_ROSTER";
export const UPDATE_SETTINGS = "UPDATE_SETTINGS";
export const UPDATE_DATABASE = "UPDATE_DATABASE";

export const CREATE_STUDENT = "CREATE_STUDENT";
export const UPDATE_STUDENTLIST = "UPDATE_STUDENTLIST";
export const DELETE_STUDENT = "DELETE_STUDENT";
export const DELETE_ROSTER = "DELETE_ROSTER";

export const UPDATE_SPECIFIC_STUDENT_INFO = "UPDATE_SPECIFIC_STUDENT_INFO";
export const UPDATE_STUDENT_INFO = "UPDATE_STUDENT_INFO";
export const UPDATE_OLD_STUDENT_INFO = "UPDATE_OLD_STUDENT_INFO";
export const UPDATE_DB_RESPONSE = "UPDATE_DB_RESPONSE";

//Not supported yet-----------------------------------------
export const UPDATE_WEEKLY_POINTS = "UPDATE_WEEKLY_POINTS";
export const UPDATE_TOTAL_POINTS = "UPDATE_TOTAL_POINTS";
export const UPDATE_POINTS_POSSIBLE = "UPDATE_POINTS_POSSIBLE";
export const UPDATE_GRADE_PERCENTAGE = "UPDATE_GRADE_PERCENTAGE";

//Not supported yet-----------------------------------------
export const UPDATE_ATTENDANCE = "UPDATE_ATTENDANCE";
